import type { IPlaceholderConfig, ITemplatePageConfig } from '~/types/template'

import { page4CommonBlocks, page4CommonPlaceholders } from './common'

import BackgroundImageBlock from '~/components/DynamicScreen/Blocks/BackgroundImage'
import ButtonBlock from '~/components/DynamicScreen/Blocks/Button'
import FrameBlock from '~/components/DynamicScreen/Blocks/Frame'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'
import ToggleBlock from '~/components/DynamicScreen/Blocks/Toggle'
import ToggleBackgroundBlock from '~/components/DynamicScreen/Blocks/ToggleBackground'
import { EmptyBlock } from '~/components/DynamicScreen/utils'

const placeholders: IPlaceholderConfig[] = [
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31', translation: 'onboarding_slide_purchasing_notsure' },
    placeholderKey: 'toggle_txt_4a_1',
    type: ['color', 'translation'],
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31', translation: 'onboarding_slide_purchasing_enableft' },
    filters: ['eligible'],
    placeholderKey: 'toggle_txt_4a_2',
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    component: ButtonBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'action_buy_cta_4a',
    type: 'color',
  },
  {
    category: 'button',
    className: 'button-text',
    component: TextBlock,
    defaultValue: { color: '#FFFFFF', translation: 'common.continue' },
    iapKey: 'iap_1',
    placeholderKey: 'buy_txt_4a',
    type: ['color', 'translation'],
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    iapKey: 'iap_1',
    placeholderKey: 'price_txt_4a',
    previewProperties: {
      text: '€49,99 per year',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'toggle',
    component: ToggleBlock,
    defaultValue: { color: '#E6E6E6' },
    placeholderKey: 'action_variant_4a',
    type: 'color',
  },
  {
    category: 'in-app',
    component: EmptyBlock,
    placeholderKey: 'iap_1',
    type: 'iap',
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31', translation: 'enable_weekly_sub' },
    filters: ['not_eligible'],
    placeholderKey: 'toggle_txt_4c_1',
    previewProperties: { text: 'Enable weekly billing' },
    type: ['color', 'translation'],
  },
  {
    category: 'background',
    component: FrameBlock,
    defaultValue: { color: '#dbdbdb' },
    placeholderKey: 'toggle_shape_4a_border',
    type: 'color',
  },
  {
    category: 'background',
    component: ToggleBackgroundBlock,
    defaultValue: { color: '#ffffff' },
    placeholderKey: 'toggle_shape_4a_background',
    type: 'color',
  },
]

export const paywallPage4a: ITemplatePageConfig = {
  backgroundImage: 'background_img_4',
  blocks: page4CommonBlocks,
  className: 'page-4a',
  filters: ['eligible', 'not_eligible'],
  name: '4a. Paywall',
  placeholders: [
    ...page4CommonPlaceholders,
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_img_4',
      type: 'asset',
    },
  ],
}

export const paywallPage4aVideo: ITemplatePageConfig = {
  ...paywallPage4a,
  backgroundImage: 'background_video_4',
  placeholders: [
    ...page4CommonPlaceholders,
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_video_4',
      type: 'asset',
    },
  ],
}
